import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-gitlab', 'BrandGitlab', [["path",{"d":"M11.981 21 21 13.708 18.498 3l-3.015 6.497H8.997L5.507 3 3 13.708z","key":"svg-0"}]]);